<template>
  <div class="contents">
    <div class="layout">

      <div class="page-top">
        <h2>공모전 관리</h2>
        <div class="breadcrumbs">
          <span>컨텐츠 관리</span>
          <span class="color-black">공모전 관리</span>
        </div>
      </div>

      <div class="list-top mt50">
        <h3></h3>
        <div class="control-group">
          <div class="btn-group">
            <button @click="deleteItems" type="button" class="delete-button">삭제</button>
            <button @click="addContest" type="button" class="navy-button add-button">등록</button>
          </div>
        </div>
      </div>

      <div class="white-panel mt20">
        <div class="table-wrap">
          <div class="scroll-box">
            <table class="table-type1">
              <colgroup>
                <col style="width: 5%;">
                <col style="width: 5%;">
                <col >
                <col style="width: 12%;">
                <col style="width: 5%;">
                <col style="width: 8%;">
                <col style="width: 8%;">
                <col style="width: 8%;">
                <col style="width: 7%;">
                <col style="width: 7%;">
                <col style="width: 10%;">
              </colgroup>
              <thead>
              <tr>
                <th>
                  <span class="checkbox-type1">
                    <input
                        type="checkbox"
                        id="allchk"
                        :checked="isAllSelected"
                        @change="toggleAllCheck($event)"
                        aria-label="전체 선택"
                    />
                    <label for="allchk">체크</label>
                  </span>
                </th>
                <th>NO</th>
                <th>제목</th>
                <th>주최기관</th>
                <th>미리보기</th>
                <th>공개여부</th>
                <th>등록일</th>
                <th>변경일</th>
                <th>지원자</th>
                <th>지원자(중복 제거)</th>
                <th>지원자목록</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(item, index) in contests" :key="item.uuid">
                <td>
                  <span class="checkbox-type1">
                    <input
                        type="checkbox"
                        :id="item.uuid"
                        :value="item.uuid"
                        v-model="selectedItems"
                        aria-label="개별 선택"
                    />
                    <label :for="item.uuid">체크</label>
                  </span>
                </td>
                <td>{{ index + 1 }}</td>
                <td>
                  <router-link :to="`/content/contest/${item.uuid}`" class="ellipsis-link">
                    {{ item.title }}
                  </router-link>
                </td>
                <td>
                  <span v-if="item.organizationName" class="organization-name">
                    {{ item.organizationName }}
                  </span>
                  <span v-else class="text-muted">-</span>
                </td>
                <td>
                  <button @click="openContestFormPreview(item.articleNewsId)">🔗</button>
                </td>
                <td>
                  {{ item.isActive ? '공개' : '비공개' }}
                </td>
                <td>{{ formatDate(item.createdAt) }}</td>
                <td>{{ formatDate(item.updatedAt) }}</td>
                <td>{{ item.totalSubmissionCount }}</td>
                <td>{{ item.applicantCount }}</td>
                <td>
                  <button @click="downloadExcel(item.title, item.uuid)" class="btn btn-primary">
                    {{ excelDownLoadMessage }}
                  </button>
                  <!-- 지원자 관리 (mimio#80) — 지원 당시 포트폴리오를 웹에서 본다 -->
                  <router-link
                    :to="{ name: 'ContestApplicants', params: { uuid: item.uuid } }"
                    class="btn btn-outline-primary zip-button"
                  >
                    지원자 관리
                  </router-link>
                  <!-- 지원자 파일 전체를 ZIP 하나로 (mimio#79). 번호는 엑셀 No 와 같다 -->
                  <button
                    @click="downloadFilesZip(item)"
                    class="btn btn-outline-primary zip-button"
                    :disabled="!item.applicantCount || zipPreparing === item.uuid"
                  >
                    {{ zipPreparing === item.uuid ? '준비 중...' : '파일 전체(ZIP)' }}
                  </button>
                </td>
              </tr>
              <tr v-if="contests.length === 0">
                <td colspan="10" class="text-center">등록된 공모전이 없습니다.</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script setup>
import {ref, onMounted, computed} from 'vue';
import {useRouter} from 'vue-router';
import {apiClient} from '@/services/auth-header';
import {format} from 'date-fns';
const contests = ref([]);
const selectedItems = ref([]);
const excelDownLoadMessage = ref('다운로드(엑셀)');
const router = useRouter();
const API_URL = '/contents/contests';

// Platform URL (환경별로 다름)
const platformUrl = process.env.VUE_APP_PLATFORM_URL || process.env.VUE_APP_REDIRECT_URI || 'https://mimio.life';

const openContestFormPreview = async (articleNewsId) => {
  const {data} = await apiClient.get(`/contents/articles/news/uuid-by-id/${articleNewsId}`);
  const url = `${platformUrl}/article/news/${data}/contest-preview`;
  window.open(url, '_blank', 'noopener,noreferrer');
};

const downloadExcel = async (title, uuid) => {
  excelDownLoadMessage.value = '다운로드 중...';
  try {
    const response = await apiClient.get(`${API_URL}/${uuid}/export`, {
      responseType: 'blob', // 중요: 바이너리로 받아야 함
    });

    const blob = new Blob([response.data], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `[${title}]_신청자목록.xlsx`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error('엑셀 다운로드 실패:', error);
    alert('엑셀 다운로드 중 오류가 발생했습니다.');
  } finally {
    setTimeout(() => {
      excelDownLoadMessage.value = '다운로드(엑셀)';
    }, 500);
  }
};

// 지원자 파일 전체 ZIP (mimio#79).
// 서버가 S3 에서 하나씩 읽어 흘려보내는 큰 파일이라 axios(blob)로 받으면 브라우저 메모리에 통째로 쌓인다.
// 그래서 로그인 상태로 1회용 티켓(5분)만 받고, 실제 다운로드는 브라우저 기본 다운로드에 맡긴다.
const zipPreparing = ref('');
const downloadFilesZip = async (item) => {
  zipPreparing.value = item.uuid;
  try {
    const { data } = await apiClient.post(`${API_URL}/${item.uuid}/files-zip/ticket`);
    window.location.href = `${apiClient.defaults.baseURL}${data.path}`;
  } catch (error) {
    console.error('ZIP 다운로드 준비 실패:', error);
    alert('파일 다운로드를 준비하지 못했습니다.');
  } finally {
    setTimeout(() => {
      zipPreparing.value = '';
    }, 1500);
  }
};

const fetchItems = async () => {
  try {
    const {data} = await apiClient.get(API_URL);

    contests.value = data;
    selectedItems.value = [];
  } catch (error) {
    console.error('공모전 목록 조회 실패:', error);
    alert('공모전 목록을 불러오는 중 오류가 발생했습니다.');
  }
};

const deleteItems = async () => {
  if (selectedItems.value.length === 0) {
    alert('삭제할 항목을 선택하세요.');
    return;
  }
  if (!confirm('선택한 공모전을 삭제하시겠습니까?')) {
    return;
  }
  try {
    await apiClient.delete(API_URL, {data: selectedItems.value});
    alert('삭제되었습니다.');
    await fetchItems();
  } catch (error) {
    console.error('삭제 실패:', error);
    alert('삭제 중 오류가 발생했습니다.');
  }
};

const addContest = () => {
  router.push({ name: 'ContestCreate' });
};

const isAllSelected = computed(() => {
  return contests.value.length > 0 && selectedItems.value.length === contests.value.length;
});

const toggleAllCheck = (event) => {
  if (event.target.checked) {
    selectedItems.value = contests.value.map(item => item.uuid);
  } else {
    selectedItems.value = [];
  }
};

const formatDate = (dateString) => {
  if (!dateString) return '-';
  try {
    return format(new Date(dateString), 'yyyy-MM-dd');
  } catch {
    return dateString;
  }
};

onMounted(fetchItems);
</script>

<style scoped>
.zip-button { margin-left: 6px; }
.ellipsis-link {
  display: inline-block;
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.organization-name {
  display: inline-block;
  max-width: 120px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #495057;
  font-weight: 500;
}

.text-muted {
  color: #6c757d;
}

.text-center {
  text-align: center;
}
</style>
